<script setup lang="ts">
import {
  EventFieldsFragment,
  LandingPageFieldsFragment,
  NodeCbzLandingPage,
  NewsFieldsFragment,
  NodeProtectedPage,
  OpenJobFieldsFragment,
  PageFieldsFragment,
  ToccoSeminarFieldsFragment,
  ContainerWidgetMain,
} from '~/api/graphql/generated'

const props = defineProps<{
  entity:
    | PageFieldsFragment
    | EventFieldsFragment
    | OpenJobFieldsFragment
    | NodeCbzLandingPage
    | NodeProtectedPage
    | LandingPageFieldsFragment
    | NewsFieldsFragment
    | ToccoSeminarFieldsFragment
    | ContainerWidgetMain
}>()

const rawSections = useSections(props.entity.fieldWidgets)
const sections = computed(() =>
  rawSections.map((s) => ({
    ...s,
    dataId: ((s.entity as unknown as { fieldId?: string })?.fieldId ?? undefined) as string | undefined,
  })),
)
</script>

<template>
  <component
    :is="section?.name"
    v-for="(section, index) in sections"
    :key="`${section?.name}-${index}`"
    :entity="section.entity"
    :data-id="section.dataId"
  />
</template>
